import _ from 'lodash';
import { getField, updateField } from 'vuex-map-fields';
const state = {
    basico: {
        nombre: null,
        apellido: null,
        celular: null,
        whatsapp: null,
        ubicacion_id: null,
        ubicacion_name: null,
        email: null,
        origen: null,
        canal: null,
        presupuesto: 0,
        min_mostrar: 0,
        fecha_cita: null
    },
    inventario: {
        fichatecnica: {
            tipo_plan: ''
        },
        modelorel: {
            modelo: null,
            marca: {
                name: null
            },
            lineas: {
                name: null
            },
            version: {
                name: null,
                cod_fasecolda: null,

                meta_keys: {
                    clindraje: 0
                }
            }
        },
    },
    forma_pago: {
        opciones: [],
        efectivo: null,
        efectivo_valor: 0,
        usado: null,
        credito: null,
        conseguir: null
    },
    vehiculo_usado: {
        id_modelo: "",
        val_modelo: "",
        id_marca: "",
        val_marca: "",
        id_linea: "",
        val_linea: "",
        id_version: "",
        val_version: "",
        kilometraje: "",
        titulo_usado: "",
        precio_estimado: 0,
        estado: "pendiente",  
    },
    cotizacion: {
        vr_publicacion: 0,
        vr_retoma: 0,
        vr_sugerido: 0,
        vr_minimo: 0,
        created_at: null
    },
    credito_form: {
        estado: 'pendiente',
        actividad: null,
        tiempo_actividad: '',
        plazo: null,
        ingresos: '',
        valor_financiar: '',
        otro: ''
    },
    credito_actividades: [],
    vehiculo_conseguir: {
        tipo_busqueda: null,
        marca_id: '',
        modelo_id: '',
        linea_id: '',
        version_id: '',
        val_marca: null,
        val_linea: null,
        titulo_vehiculo: '',
        tags_vehiculos: [],
        tags_marcas: [],
        rango_precio: [],
        rango_ano: [],
    },
    opciones_busqueda: [],
    canales: []
};
const mutations = {
    updateField,
    updateNecesidad: (state, payload) => {
        state.basico.nombre = payload.clientes.nombre
        state.basico.apellido = payload.clientes.apellido
        state.basico.celular = payload.clientes.celular
        state.basico.whatsapp = payload.clientes.whatsapp
        state.basico.ubicacion_id = payload.clientes.ubicacion_id
        state.basico.ubicacion_name = payload.clientes.ubicacion_name
        state.basico.email = payload.clientes.email

        state.basico.origen = payload.origen;
        state.basico.canal = payload.canal;
        state.inventario = payload.inventario;
        state.canales = payload.canales;
        var sizeNecesidad = Object.keys(payload.necesidad).length;
        if (sizeNecesidad === 0) {
            state.basico.presupuesto = payload.inventario.fichatecnica.precio_publicacion;
        }else{
            state.basico.presupuesto = payload.necesidad.basico.presupuesto;
            state.basico.fecha_cita = payload.necesidad.basico.fecha_cita;
            state.vehiculo_conseguir = payload.necesidad.vehiculo_conseguir;
            state.credito_form = payload.necesidad.credito_form;
            //fill metodos de pago
            state.forma_pago = {...state.forma_pago, ...payload.necesidad.forma_pago};
            state.vehiculo_usado = payload.necesidad.vehiculo_usado;
        }
        var calculate_minimun = payload.inventario.fichatecnica.precio_publicacion * 0.1;
        state.basico.min_mostrar = payload.inventario.fichatecnica.precio_publicacion - calculate_minimun;
        if(payload.usado && payload.usado.estado_principal !== 'cotizacion'){
            state.vehiculo_usado.estado = 'cotizado';
            state.cotizacion.created_at = payload.usado.created_at;
            state.cotizacion.vr_publicacion = payload.usado.fichatecnica.cotizacion.vr_publicacion;
            state.cotizacion.vr_retoma = payload.usado.fichatecnica.cotizacion.vr_retoma;
            state.cotizacion.vr_sugerido = payload.usado.fichatecnica.cotizacion.vr_sugerido;
            state.cotizacion.vr_minimo = payload.usado.fichatecnica.cotizacion.vr_minimo;
        }
        if(payload.credito){
            state.credito_form.estado = payload.credito.status;
            state.credito_actividades = payload.credito.actividades;
        }
    },
    updateCredito: (state, payload) => {
        if(payload){
            state.credito_form.estado = payload.status;
            state.credito_actividades = payload.actividades;
        }
    }
};

const getters = {
    getField
};

const actions = {

};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
